// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3119) return "static/chunks/3119-629e3786d186de66.js";
	if (chunkId === 3859) return "static/chunks/3859-f5932ecccbfe666d.js";
	if (chunkId === 9617) return "static/chunks/9617-5a176eeed7ed9e71.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2443":"9e7b7c37d80af8cb","2460":"af6652233811a94f","2648":"87330b186d5ef4a9","2823":"bfa86cfcf65d3e3b","4654":"95c0b298bf870252","5192":"141f2c1db6f8ffa8","5355":"5bfb846496647947","7247":"7093c63ed336caca","8395":"7cc83f8573d36ca6","9595":"b85f0dcd673e020a","9718":"bcedb8f65218b557"}[chunkId] + ".js";
};